module.exports = __webpack_public_path__ + "static/media/guodu.logo-l.832a7204.png";